import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { brands } from 'src/app/shared/constantes';
import { cifValidator, dniValidator, getMaxLengthByDoc, nieValidator } from 'src/app/utils/validators/spanish-id-validator';
import { ApiAmenaService } from '../../services/api-amena.service';
import { GeneralService } from '../../services/general.service';
import { NormalizadorService } from '../../services/normalizador.service';

@Component({
    selector: 'app-customer',
    templateUrl: './customer.component.html',
    styleUrls: ['./customer.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class CustomerComponent implements OnInit {
    @Input() formGroup: FormGroup;

    public loaded: boolean = true;
    public isCustomer: boolean = false;
    public showErrorCustomer: boolean = false;
    public showNotCustomer: boolean = false;
    public customerInfo: any;
    public maxLengthByDoc = 9;
    public route;
    public documentTypes;
    public productsFormGroup: FormGroup;
    public mainAccExpanded: boolean = false;
    public agreementsSelected: any[] = [];
    public showAgreements: boolean = false;
    public technologies = {
        ftth_dir: 'Fibra directa',
        ftth_ind: 'Fibra indirecta',
        adsl: 'ADSL'
    };

    constructor(
        private amenaService: ApiAmenaService,
        private modalService: NgbModal,
        private normalizadorService: NormalizadorService,
        private formBuilder: FormBuilder,
        private generalService: GeneralService,
        private _router: Router
    ) {
        this.route = this._router.url;

        this.productsFormGroup = this.formBuilder.group({
            products: new FormArray([])
        });
    }

    ngOnInit(): void {
        this.formGroup.get('customer_doctype').disable();
        this.amenaService.getDataFromNotCustomer()
            .subscribe((data: any) => {
                if (data) {
                    this.setDataFromNotCustomer(data);
                }
            });

        this.amenaService.getDocumentTypes()
            .subscribe((data: any) => {
                if (data && !this.documentTypes) {
                    this.documentTypes = data;
                    this.formGroup.get('customer_doctype').enable();
                }
            });
    }

    setNotCustomer() {
        this.isCustomer = false;
        this.amenaService.setDataFromNotCustomer(this.formGroup.getRawValue());
        this.next();
    }

    next(content?) {
        if (this.formGroup.valid) {
            if (this.isCustomer) {
                const body = {
                    document_type: this.formGroup.value.customer_doctype,
                    document_number: this.formGroup.value.customer_doc
                }
                this.loaded = false;
                this.showErrorCustomer = false;
                this.amenaService.getCustomerInfoFromService(body)
                    .subscribe((response : any) => {
                        if (response && response.msg) {
                            this.showNotCustomer = false;
                            this.customerInfo = response.msg;
                            if (this.customerInfo.products && this.customerInfo.products.length) {
                                (this.productsFormGroup.get('products') as FormArray).clear();
                                this.customerInfo.products.map(x => (this.productsFormGroup.get('products') as FormArray).push(new FormControl(false)));
                                if (this.route !== '/amena/solo_movil') {
                                    this.customerInfo.productsCount = this.customerInfo.products.length;
                                } else {
                                    let productsCount = 0;
                                    this.customerInfo.products.map(x => productsCount += x.type === 'mobile' ? 1 : 0);
                                    this.customerInfo.productsCount = productsCount;
                                }
                            }
                            this.open(content);
                        } else {
                            this.showNotCustomer = true;
                        }
                    }, error => {
                        if (error && error.error && error.error.error && error.error.error.simyo_code && error.error.error.simyo_code === 631) {
                            this.showNotCustomer = true;
                        } else {
                            this.showErrorCustomer = true;
                        }
                        this.loaded = true;
                    }, () => {
                        this.loaded = true;
                    })
            } else {
                this.normalizadorService.setClientIsCover(true);
            }
        } else {
            const elements: any = document.getElementsByClassName('mat-input-element ng-invalid');

            if (elements.length > 0) {
                elements[0].focus();
            }
        }
    }

    notMigration() {
        if (this.customerInfo) {
            this.amenaService.setDataFromCustomer(this.customerInfo);
            this.amenaService.setDataFromNotCustomer(this.formGroup.getRawValue());
            this.normalizadorService.setClientIsCover(true);
        }

    }

    migrationProducts(confirmation?) {
        if (this.customerInfo && this.selectedAnyProduct()) {
            let productSelected:any[] = [];
            (this.productsFormGroup.get('products') as FormArray).controls.forEach((element, index) => {
                if (element && element.value) {
                    productSelected.push(this.customerInfo.products[index]);
                }
            });
            if (productSelected && productSelected.length) {
                this.agreementsSelected = [];
                // Buscamos si hay penalizaciones tanto la línea como el terminal
                productSelected.map(product => {
                    if (product && ((product.agreements && product.agreements.length) || (product.terminal && product.terminal !== '' && product.terminal.agreement))) {
                        this.agreementsSelected.push(product);
                    }
                });
                if (this.agreementsSelected && this.agreementsSelected.length && !confirmation) {
                    this.showAgreements = true;
                } else {
                    const mobilePacks: any[] = [];
                    let landlineConfigurationForm: any;
                    let anyPostpaid: boolean = false;
                    let migrationFibra: boolean = false;
                    let normalizacionForm: any;
                    let migrationFibraData: any = {};
    
                    productSelected.forEach((element, index) => {
                        if (element && element.type === 'mobile') {
                            const stepper_index = index + (this.route !== '/amena/solo_movil' ? 1 : 0);
                            mobilePacks.push({
                                type_operation: 'migration',
                                rate: null,
                                principal: element.main_line,
                                portability_phone: element.msisdn && element.msisdn !== '' ? element.msisdn : '',
                                portability_operator: '',
                                portability_type_client: element.paytype && element.paytype !== '' ? element.paytype : '',
                                portability_iccid: '',
                                portability_client: '',
                                iccid: '',
                                terminal: '',
                                terminal_payment_type: '',
                                terminal_insurance: '',
                                stepper_index: stepper_index,
                                resegmentation: true,
                                resegmentation_from_type: element.from_type,
                                resegmentation_type: element.paytype,
                                cp_vat: (element.agreements && element.agreements.length > 0) ? element.agreements[0].vat : null,
                                cp_price: (element.agreements && element.agreements.length > 0) ? element.agreements[0].price : null,
                                cp_price_without_vat: (element.agreements && element.agreements.length > 0) ? element.agreements[0].price_without_vat : null,
                            });
                            if (element.paytype === 'postpaid') {
                                anyPostpaid = true;
                            }
                        }
    
                        if (element && element.type === 'broadband') {
                            anyPostpaid = true;
                            migrationFibra = true;
                            migrationFibraData = element;
                            landlineConfigurationForm = {
                                type_operation: 'migration',
                                phone_portability: element.msisdn && element.msisdn !== '' ? element.msisdn : '',
                                operator_portability: '',
                                cp_vat: (element.agreements && element.agreements.length > 0) ? element.agreements[0].vat : null,
                                cp_price: (element.agreements && element.agreements.length > 0) ? element.agreements[0].price : null,
                                cp_price_without_vat: (element.agreements && element.agreements.length > 0) ? element.agreements[0].price_without_vat : null
                            };
                            if (element.installation_address && element.installation_address.length) {
                                normalizacionForm = {
                                    codigoPostalNormaliza: element.installation_address[0].postCode,
                                    localidadNormaliza: element.installation_address[0].city,
                                    nombreViaNormaliza: element.installation_address[0].streetName,
                                    numeroNormaliza: element.installation_address[0].streetNr,
                                    provinciaNormaliza: element.installation_address[0].stateOrProvince,
                                    tipoViaNormaliza: element.installation_address[0].streetType,
                                };
                            }
                        }
                    });
    
                    if (mobilePacks && mobilePacks.length > 1) {
                        // Ordenamos el array
                        let indexMobile: number = 0;
                        let indexMobileAdicional: number = 0;
                        mobilePacks.forEach(element => {
                            if (element.principal) {
                                indexMobile = this.route !== '/amena/solo_movil' ? 1 : 0;
                            } else {
                                indexMobileAdicional++;
                                indexMobile = indexMobileAdicional + (this.route !== '/amena/solo_movil' ? 1 : 0)
                            }
                            element.stepper_index = indexMobile;
                        });
                    }
                    this.generalService.setEmptyFormLandlineConfiguration(landlineConfigurationForm);
                    this.generalService.setEmptyFormMobilePackAll(mobilePacks.sort(this.compare));
                    this.generalService.setEmptyFormNormalizacion(normalizacionForm);
                    this.amenaService.setMigrationData({
                        migrationshowBanking: anyPostpaid,
                        migrationFibra: migrationFibra,
                        migrationFibraData: migrationFibraData
                    });
                    this.modalService.dismissAll();
                }
            }
            this.amenaService.setDataFromCustomer(this.customerInfo);
            this.amenaService.setDataFromNotCustomer(this.formGroup.getRawValue());
            this.normalizadorService.setClientIsCover(true);
        }
    }

    open(content) {
        this.mainAccExpanded = false;
        this.showAgreements = false;
        this.changeSelectedProducts();
        this.modalService.open(content, {size: 'xl', centered: true, backdrop: 'static', keyboard : false});
    }

    setDataFromNotCustomer(dataNotCustomer) {
        // Datos personales
        if (dataNotCustomer.customer_document_type && dataNotCustomer.customer_document_type.digo_code && dataNotCustomer.customer_document_type.digo_code !== '') {
            this.formGroup.get('customer_doctype').patchValue(dataNotCustomer.customer_document_type.digo_code);
        }

        if (dataNotCustomer.customer_document && dataNotCustomer.customer_document !== '') {
            this.formGroup.get('customer_doc').patchValue(dataNotCustomer.customer_document);
        }
    }

    changeTypeDocument(value): void {
        const docValidators: ValidatorFn[] = [Validators.required];

        if (typeof value === 'number') {
            value = value.toString();
        }

        switch (value) {
            case 'DNI':
                docValidators.push(dniValidator());
                break;
            case 'NIF':
                docValidators.push(dniValidator());
                break;
            case 'NIE':
                docValidators.push(nieValidator());
                break;
            case 'CIF':
                docValidators.push(cifValidator());
                break;
            default:
        }

        this.formGroup.get('customer_doc').setValidators(docValidators);
        this.formGroup.get('customer_doc').updateValueAndValidity();
    }

    setMaxLengthByDoc(type) {
        this.maxLengthByDoc = getMaxLengthByDoc(brands.amena, type);
    }

    selectedAnyProduct(): boolean {
        if (this.customerInfo && this.customerInfo.products && this.customerInfo.products.length)  {
            const found = this.productsFormGroup.get('products').value.find(x => x)
            return found ? true : false;
        }
        return false;
    }

    changeSelectedProducts() {
        this.showAgreements = false; 
        this.agreementsSelected = [];
    }

    public getAddress(): string {
        if (this.customerInfo && this.customerInfo.postal_address) {
            let address: string = '';
            address += this.parseText(this.customerInfo.postal_address.streetType ? this.customerInfo.postal_address.streetType + ' ' : '');
            address += this.parseText(this.customerInfo.postal_address.streetName ? this.customerInfo.postal_address.streetName + ', ' : '');
            address += this.parseText(this.customerInfo.postal_address.streetNr ? this.customerInfo.postal_address.streetNr + ' ' : '');
            address += this.parseText(this.customerInfo.postal_address.floorNumber ? this.customerInfo.postal_address.floorNumber + ' ' : '');
            address += this.parseText(this.customerInfo.postal_address.apartmentNumber ? this.customerInfo.postal_address.apartmentNumber + ' ' : '');
            address += this.parseText(this.customerInfo.postal_address.staircaseNumber ? this.customerInfo.postal_address.staircaseNumber + ', ' : '');
            // address += this.parseText(this.customerInfo.postal_address.block ? this.customerInfo.postal_address.block + ', ' : ', ');
            address += this.parseText(this.customerInfo.postal_address.postCode ? this.customerInfo.postal_address.postCode + ' ' : '');
            address += this.parseText(this.customerInfo.postal_address.city ? this.customerInfo.postal_address.city + ', ' : ', ');
            address += this.parseText(this.customerInfo.postal_address.stateOrProvince ? this.customerInfo.postal_address.stateOrProvince + ' ' : '');

            return address;
        }
    }

    public parseText(text) {
        if (typeof text !== 'string') {
            return '';
        }
        let textUCfirst = '';
        for (let i = 0; i < text.length; i++) {
            if (i === 0) {
                textUCfirst += text.charAt(i).toUpperCase();
            } else {
                textUCfirst += text.charAt(i).toLowerCase();
            }
        }
        return textUCfirst;
    }

    public compare( a, b ) {
        if ( a.stepper_index < b.stepper_index ){
            return -1;
        }
        if ( a.stepper_index > b.stepper_index ){
            return 1;
        }
        return 0;
    }
}
